import { render, staticRenderFns } from "./SliderElement.vue?vue&type=template&id=55765d3c&scoped=true"
import script from "./SliderElement.vue?vue&type=script&lang=js"
export * from "./SliderElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55765d3c",
  null
  
)

export default component.exports